<template>
  <div class="pure-g">
    <div class="pure-u-md-1-5 pure-u-lg-1-4"></div>
    <div class="pure-u-1 pure-u-md-3-5 pure-u-lg-1-2">
      <div class="content box padding-30-reactive">

        <div class="pure-g" v-if="active">
          <div class="pure-u-4-5"><h3 class="responsive">{{step}}. Secure payment info</h3></div>
          <div class="pure-u-1-5 text-right">
            <button v-if="active && canEdit" v-on:click="editOverride" class="link-lookalike">Close</button>
          </div>

          <div class="pure-u-1 spacing-20"></div>

          <Loading v-if="loading"/>

          <form v-if="!loading" id="checkout-form" v-bind:class="{ hidden: formLoaded == false }"
                class="pure-u-1 pure-form pure-form-stacked font-14-sm"
                @submit.prevent="submit">
            <fieldset>
              <div id="error-message"></div>
              <div id="card-container"></div>


              <span class="pure-u-1 subtext popup" v-if="isSubscription">
                <a class="link" v-on:click="togglePopup" v-if="isSubscription">Skip months for free. Cancel anytime.</a>
                <span class="popuptext" v-bind:class="{ show: showPopup }" v-on:click="togglePopup" v-if="isSubscription">
                    {{cancelAnytime}}
                </span>
              </span>

              <Loading v-if="isBusy"/>

              <div class="pure-u-1 pure-u-sm-1-4"></div>
              <div class="pure-u-1 pure-u-sm-1-2">
                <button type="submit" class="pure-button pure-button-primary block">
                  {{buttonText}}
                </button>
                <div class="text-red" v-if="error">
                  {{ error }}
                </div>
              </div>
            </fieldset>
          </form>
        </div>

        <div v-else class="pure-g">
          <div class="pure-u-4-5"><h3 class="responsive">{{step}}. Secure payment info</h3></div>
          <div class="pure-u-1-5 text-right">
            <button v-if="canEdit" v-on:click="edit" class="link-lookalike">Change</button>
          </div>

          <ul v-if="cardLast4" class="pure-u-1 summary">
            <li>
              <div class="pure-u-1-5"></div>
              {{ this.cardType }} #### #### #### {{ this.cardLast4 }}
            </li>
          </ul>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
  import store from '../../lib/store';
  import error from '../../lib/error';
  import paymentMethods from '../../lib/payment_methods';
  import Loading from '../helpers/Loading';

  export default {
    name: 'PaymentMethodCreator',
    components: { Loading },
    props: ['active', 'step'],
    watch: {
      active() {
        if (store.get('authToken')) {
          this.getAllPaymentMethods();
        }

        if (this.active) {
          /* global ga */
          ga('send', 'pageview', `/${store.get('subscription')}/PaymentMethodCreator`);
          this.loadForm();
        }
      },
    },
    data() {
      return {
        loading: false,
        isBusy: false,
        formLoaded: false,
        cardLast4: null,
        cardType: null,
        canEdit: false,
        showPopup: false,
        error: '',
        defaultErrorMsg: 'Something went wrong, please try again',
        cancelAnytime: store.get('cancel_anytime'),
      };
    },
    computed: {
      disabled() {
        return !this.formLoaded;
      },
      buttonText() {
        if (this.canEdit) {
          return 'Update and continue';
        }
        return 'Last Step, review';
      },
      isSubscription() {
        return store.get('subscription') !== 'kuiuanchorage';
      },
    },
    methods: {
      async loadForm() {
        const applicationId = process.env.SQUARE_APPLICATION_ID;
        const locationId = process.env.SQUARE_LOCATION_ID;
        // eslint-disable-next-line
        const paymentsInstance = Square.payments(applicationId, locationId);
        this.cardInstance = await paymentsInstance.card();
        await this.cardInstance.attach('#card-container');
        this.formLoaded = true;
      },
      createPaymentMethod(token, self) {
        paymentMethods.create(token.token, (err, res) => {
          this.isBusy = false;
          if (err) {
            error.log(err);
            this.error = res.body.error;
          } else {
            store.set('paymentMethod', res.body.payment_method);
            this.cardLast4 = res.body.payment_method.card_last4;
            this.cardType = res.body.payment_method.card_type;
            this.canEdit = true;
            self.$emit('success');
          }
        });
      },
      getAllPaymentMethods() {
        paymentMethods.all((err, res) => {
          if (err) {
            this.error = this.defaultErrorMsg;
          } else if (res.body && res.body.payment_methods) {
            const defaultPaymentMethod = res.body.payment_methods.find(this.findDefault);

            if (defaultPaymentMethod) {
              this.cardLast4 = defaultPaymentMethod.card_last4;
              this.cardType = defaultPaymentMethod.card_type;
              if (!this.canEdit) {
                this.canEdit = true;
                this.$emit('success');
              }
            }
          }
        });
      },
      async submit() {
        const self = this;
        this.error = '';
        this.isBusy = true;
        const token = await this.cardInstance.tokenize();
        if (token.status === 'OK') {
          this.createPaymentMethod(token, self);
        } else {
          this.isBusy = false;
          this.error = 'Could not update payment info, please try again';
        }
      },
      edit() {
        this.cardInstance.attach('#card-container').catch();
        this.$emit('editView', 'PaymentMethodCreator');
      },
      editOverride() {
        this.cardInstance.destroy().catch();
        this.$emit('editDone');
      },
      togglePopup() {
        this.showPopup = !this.showPopup;
      },
      findDefault(item) {
        return item.is_default;
      },
    },
  };
</script>

<style scoped>
  .hosted-field {

    height: 32px;
    box-sizing: border-box;
    width: 100%;
    padding: 7px 8px 7px 8px;
    display: inline-block;
    font-weight: 600;
    font-size: 14px !important;
    border-radius: 6px;
    border: 1px solid #dddddd;
    line-height: 20px;
    background: #fcfcfc;
    margin-bottom: 12px;
    background-size: 200% 100%;
    background-position: right bottom;
    transition: all 300ms ease-in-out;
    box-shadow: inset 0 1px 3px #ddd;
  }

  /* Popup container - can be anything you want */
  .popup {
    position: relative;
    display: inline-block;
    cursor: pointer;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
  }

  /* The actual popup */
  .popup .popuptext {
    font-size: 15px;
    visibility: hidden;
    background-color: #555;
    color: #fff;
    text-align: center;
    border-radius: 6px;
    padding: 8px;
    position: absolute;
    z-index: 1;
    bottom: 125%;
    left: 60%;
    margin-left: -60%;
  }

  /* Popup arrow */
  .popup .popuptext::after {
    content: "";
    position: absolute;
    top: 100%;
    left: 50%;
    margin-left: -5px;
    border-width: 5px;
    border-style: solid;
    border-color: #555 transparent transparent transparent;
  }

  /* Toggle this class - hide and show the popup */
  .popup .show {
    visibility: visible;
    -webkit-animation: fadeIn 1s;
    animation: fadeIn 1s;
  }

  label {
    margin-top: 7px;
    margin-right: 10px;
  }

  .lock-image {
    height: 10px;
    width: 10px;
  }

</style>


// WEBPACK FOOTER //
// PaymentMethodCreator.vue?3b8456f5